<template>
    <div id="lt-yantr">
        <div class="container-width">
            <div class="loan-pay-filter-graph">
                <div class="filter-block">
                    <ul class="loan-pay-slider">
                        <li>
                            <label>How much is your loan amount?</label>
                            <div class="range-slider">
                                <div class="slider-val">
                                    <div class="val">$0</div>
                                    <number-input
                                        ref="loanAmountInput"
                                        v-model="LoanAmount"
                                        apply-input-group-addon-class="hidden"
                                        apply-input-group-class="selected-amt"
                                        apply-input-class="slider-input"
                                        inputmode="decimal"
                                        @input="resetLoanAmtVal"
                                        @inputBlur="formatLoanAmtVal"
                                    />
                                    <div class="val">$500K+</div>
                                </div>
                                <vue-slider
                                    v-model="LoanAmount"
                                    :height="loanAmtSlider.height"
                                    :tooltip="loanAmtSlider.tooltip"
                                    :bgStyle="loanAmtSlider.bgStyle"
                                    :dotSize="loanAmtSlider.dotSize"
                                    :max="loanAmtSlider.max"
                                    :min="loanAmtSlider.min"
                                    :clickable="loanAmtSlider.clickable"
                                    :interval="loanAmtSlider.interval"
                                    @drag-end="formatLoanAmtVal($event.currentValue)"
                                />
                            </div>
                        </li>
                        <li>
                            <label>What is your estimated interest rate?</label>
                            <div class="range-slider">
                                <div class="slider-val interest-val">
                                    <div class="val">1.5%</div>
                                    <number-input
                                        v-model="InterestRate"
                                        apply-input-group-addon-class="hidden"
                                        apply-input-group-class="selected-amt"
                                        apply-input-class="slider-input"
                                        precision="2"
                                        inputmode="decimal"
                                        @input="resetInterestRateVal"
                                        @inputBlur="formatInterestRateVal"
                                    />
                                    <span class="input-text">%</span>
                                    <div class="val">15%</div>
                                </div>
                                <vue-slider
                                    v-model="InterestRate"
                                    :height="interestRateSlider.height"
                                    :tooltip="interestRateSlider.tooltip"
                                    :bgStyle="interestRateSlider.bgStyle"
                                    :dotSize="interestRateSlider.dotSize"
                                    :max="interestRateSlider.max"
                                    :min="interestRateSlider.min"
                                    :clickable="interestRateSlider.clickable"
                                    :interval="interestRateSlider.interval"
                                    @drag-start="formatInterestRateVal($event.currentValue)"
                                />
                            </div>
                        </li>
                        <li>
                            <label>What is your loan term?</label>
                            <div class="range-slider">
                                <div class="slider-val term-year">
                                    <div class="val">1 year</div>
                                    <number-input
                                        v-model="LoanTerm"
                                        apply-input-group-addon-class="hidden"
                                        apply-input-group-class="selected-amt"
                                        apply-input-class="slider-input"
                                        inputmode="decimal"
                                        @input="resetLoanTerm"
                                    />
                                    <span class="input-text">year <span>term</span></span>
                                    <div class="val">30 years</div>
                                </div>
                                <vue-slider
                                    v-model="LoanTerm"
                                    :height="loanTermSlider.height"
                                    :tooltip="loanTermSlider.tooltip"
                                    :bgStyle="loanTermSlider.bgStyle"
                                    :dotSize="loanTermSlider.dotSize"
                                    :max="loanTermSlider.max"
                                    :min="loanTermSlider.min"
                                    :clickable="loanTermSlider.clickable"
                                    :interval="loanTermSlider.interval"
                                    @drag-start="formatInterestRateVal($event.currentValue)"
                                />
                            </div>
                        </li>
                    </ul>

                    <div class="loan-pay-graph">
                        <div class="graph-block">
                            <div class="circle-graph">
                                <div class="circle-content">
                                    <label>Monthly Payment:</label>
                                    <big>${{ currencyFilter(monthlyPayment) }}</big>
                                    <ul>
                                        <li>
                                            <label>Total Interest:</label>
                                            <strong>${{ currencyFilter(totalPaymentInterest) }}</strong>
                                        </li>
                                        <li>
                                            <label>Total Repayment:</label>
                                            <strong>${{ currencyFilter(allTotalPayment) }}</strong>
                                        </li>
                                    </ul>
                                </div>
                                <div class="inner-circle"></div>
                                <div class="outer-circle">
                                    <vue-chart
                                        type="doughnut"
                                        :data="chartData"
                                        :options="options"
                                        :width="chartWidth"
                                        :height="chartHeight"
                                    />
                                </div>
                            </div>
                        </div>
                        <ul class="chart-info">
                            <li><span class="green-bg"></span> Principal</li>
                            <li><span class="light-green-bg"></span> Interest</li>
                        </ul>
                    </div>
                    <div class="clear-fix"></div>

                    <div class="view-free-offers">
                        <h4>We've found offers for this result:</h4>
                        <button class="btn btn-blue" type="submit" @click="redirect()">{{ DestinationButtonText }}</button>
                        <div class="clear-fix"></div>
                        <advertising-disclosures v-if="DisclosureText" :disclosure-text="DisclosureText" :disclosure-tokens="DisclosureTokens" />
                        <lt-logo v-if="ltLogo==1">
                            <small>NMLS#1136 Terms & Conditions Apply</small>
                        </lt-logo>
                    </div>
                    <div class="clear-fix"></div>
                </div>
            </div>

            <div class="full-width-border"></div>

            <home-loan-mo-pay-graph
                v-if="moPayGraphSection==1"
                :loan-data="amortizationBreakdown"
            />

            <home-loan-amortization-table
                v-if="amortizationTableSection==1"
                :amortization-breakdown="amortizationBreakdown"
            />

            <div class="full-width-border"></div>
        </div>
    </div>
</template>

<script>
    import vueSlider from 'vue-slider-component';
    import Accounting from 'accounting';
    import VueChart from 'vue-chart-js';
    import NumberInput from '~/components/number-input.vue';
    import HomeLoanMoPayGraph from '~/components/home-loan-mo-pay-graph.vue';
    import HomeLoanAmortizationTable from '~/components/home-loan-amortization-table.vue';
    import LtLogo from '~/components/lt-logo.vue';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import PaymentHelper from '~/helpers/payment';
    import BaseMixin from '~/mixin/base-mixin';
    import ResetLoanPaymentSlider from '~/mixin/reset-loan-payment-slider';
    import AmortizationBreakdownHelper from '~/helpers/amortization-breakdown';

    export default {
        props: {
            ltLogo: {
                default: 0,
            },
            loanAmount: {
                default: 150000,
            },
            interestRate: {
                default: 2,
            },
            loanTerm: {
                default: 30,
            },
            disclosureTokens: {
                default: '00101',
            },
            disclosureText: {
                default: 'Advertising Disclosures',
            },
            moPayGraphSection: {
                default: 1,
            },
            amortizationTableSection: {
                default: 1,
            },
            destinationLinkOrId: {
                default: 'ns-calc-loan-payment',
            },
            destinationButtonText: {
                default: 'View Free Offers',
            },
        },
        data() {
            return {
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                loanAmtSlider: {
                    value: 150000,
                    height: 3,
                    sliderStyle: {
                        backgroundColor: '#00aeef',
                    },
                    bgStyle: {
                        background: '#ccc',
                    },
                    dotSize: 16,
                    tooltip: false,
                    clickable: false,
                    min: 0,
                    max: 500000,
                    interval: 1000,
                },
                LoanAmount: this.loanAmount,
                LoanIntAmount: this.loanAmount,
                interestRateSlider: {
                    value: 2,
                    height: 3,
                    sliderStyle: {
                        backgroundColor: '#00aeef',
                    },
                    bgStyle: {
                        background: '#ccc',
                    },
                    dotSize: 16,
                    tooltip: false,
                    clickable: false,
                    min: 1.5,
                    max: 15,
                    interval: 0.1,
                },
                InterestRate: typeof this.interestRate == 'undefined' ? 3.3 : this.interestRate,
                loanTermSlider: {
                    value: 30,
                    height: 3,
                    sliderStyle: {
                        backgroundColor: '#00aeef',
                    },
                    bgStyle: {
                        background: '#ccc',
                    },
                    dotSize: 16,
                    tooltip: false,
                    clickable: false,
                    min: 1,
                    max: 30,
                    interval: 1,
                },
                LoanTerm: this.loanTerm,
                // Setting for chart
                chartData: {
                    labels: ['Total Interest'],
                    datasets: [
                        {
                            data: [250],
                            backgroundColor: 'rgb(212, 238, 231)',
                            hoverBackgroundColor: 'rgb(212, 238, 231)',
                            borderWidth: 0,
                        },
                    ],
                },
                chartWidth: 280,
                chartHeight: 280,
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
            };
        },
        methods: {
            formatLoanAmtVal() {
                this.LoanIntAmount = this.unformatFigure(this.LoanAmount);
                this.LoanAmount = Accounting.formatMoney(this.LoanAmount, { symbol: '$', precision: 0 });
            },
            formatInterestRateVal() {
                this.LoanAmount = Accounting.formatMoney(this.LoanIntAmount, { symbol: '$', precision: 0 });
            },
            currencyFilter(figure) {
                return figure > 0 ? Accounting.formatNumber(figure, { precision: 2 }) : 0;
            },
            currencyFilterPreZero(figure) {
                return Accounting.formatNumber(figure, { precision: 0 });
            },
            loadCircleChart() {
                const inerCircle = this.allTotalPayment / 8000000 + 0.66;
                let outerCircle = this.allTotalPayment / 8000000 + 0.53 + this.totalPaymentInterest / this.allTotalPayment * 0.35;
                outerCircle = isFinite(outerCircle) ? outerCircle : 0;
                outerCircle = this.allTotalPayment === 0 ? 0 : outerCircle;
                document.getElementsByClassName('inner-circle')[0].style.transform = `matrix(${inerCircle}, 0, 0,${inerCircle}, 0, 0)`;
                document.getElementsByClassName('outer-circle')[0].style.transform = `matrix(${outerCircle}, 0, 0,${outerCircle}, 0, 0)`;
            },
        },
        computed: {
            getInterestRate() {
                return this.InterestRate;
            },
            monthlyPayment() {
                return PaymentHelper.monthlyPaymentUsingLoanTermInYears(this.LoanIntAmount, this.LoanTerm, this.InterestRate);
            },
            totalPaymentInterest() {
                return this.monthlyPayment * (this.LoanTerm * 12) - this.LoanIntAmount;
            },
            allTotalPayment() {
                return this.totalPaymentInterest + this.LoanIntAmount;
            },
            amortizationBreakdown() {
                return AmortizationBreakdownHelper.amortizationBreakdown(this.LoanIntAmount, this.LoanTerm, this.InterestRate);
            },
            options() {
                const self = this;
                return {
                    cutoutPercentage: 0,
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        enabled: false,
                        custom(tooltip) {
                            let tooltipEl = document.getElementById('chartjs-tooltip');
                            if (!tooltipEl) {
                                tooltipEl = document.createElement('div');
                                tooltipEl.id = 'chartjs-tooltip';
                                tooltipEl.innerHTML = '<div></div>';
                                document.getElementsByClassName('circle-content')[0].append(tooltipEl);
                            }
                            if (tooltip.opacity === 0) {
                                tooltipEl.style.opacity = 0;
                                return;
                            }
                            tooltip.displayColors = false;
                            tooltipEl.classList.remove('above', 'below', 'no-transform');
                            if (tooltip.yAlign) {
                                tooltipEl.classList.add(tooltip.yAlign);
                            } else {
                                tooltipEl.classList.add('no-transform');
                            }
                            // getBody function description: bodyItem
                            // return type bodyItem
                            /**
                             * @param {bodyItem} bodyItem the number
                             * @returns {void}
                             */
                            function getBody(bodyItem) {
                                return bodyItem.lines;
                            }
                            // Set Text
                            if (tooltip.body) {
                                let innerHtml = '';
                                const titleLines = tooltip.title || [];
                                const bodyLines = tooltip.body.map(getBody);
                                titleLines.forEach((title) => {
                                    innerHtml += `<label>${title}</label>`;
                                });
                                bodyLines.forEach((body) => {
                                    const bodaySplit = body[0].split(':');
                                    innerHtml += `<label>${bodaySplit[0]}</label>`;
                                    innerHtml += `<strong>${Accounting.formatMoney(self.totalPaymentInterest, { precision: 2 })}</strong>`;
                                });
                                const tableRoot = tooltipEl.querySelector('div');
                                tableRoot.innerHTML = innerHtml;
                            }
                            this._chart.canvas.addEventListener('mousemove', (evt) => {
                                if (this && this.getBoundingClientRect) {
                                    const rect = this.getBoundingClientRect();
                                    const positionX = evt.clientX - rect.left - rect.width / 2 + 50;
                                    const positionY = evt.clientY - rect.top - rect.height / 2 + 25;
                                    tooltipEl.style.left = `${positionX}px`;
                                    tooltipEl.style.top = `${positionY}px`;
                                }
                            }, false);
                            tooltipEl.style.opacity = 1;
                        },
                    },
                };
            },
            circleChart() {
                return this.LoanIntAmount + this.LoanTerm + this.InterestRate;
            },
        },
        mounted() {
            this.$refs.loanAmountInput.updateFormatedValue(Accounting.formatMoney(this.LoanAmount, { symbol: '$', precision: 0 }));
            this.loadCircleChart();
        },
        components: {
            NumberInput,
            vueSlider,
            HomeLoanMoPayGraph,
            HomeLoanAmortizationTable,
            VueChart,
            LtLogo,
            AdvertisingDisclosures,
        },
        watch: {
            circleChart() {
                this.loadCircleChart();
            },
            getInterestRate() {
                this.InterestRate = Accounting.formatMoney(this.InterestRate, { symbol: '', precision: 3 });
            },
        },
        mixins: [BaseMixin, ResetLoanPaymentSlider],
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<!-- Below main.scss file is common for "Home Loan Payment & Home Loan Payment Lite & Loan Payment V2" Calculator. -->
<style src="./main.scss" lang="scss"></style>
